import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Lock } from "lucide-react";

export default function AccessDenied({ role }) {
    return (
        <main className="min-h-[calc(100vh-4rem)] flex flex-col items-center justify-center px-6 text-center">
            <div className="p-5 rounded-full bg-brand-magenta/10 border border-brand-magenta/30 mb-6">
                <Lock className="w-8 h-8 text-brand-magenta" />
            </div>
            <p className="font-mono-tag text-xs uppercase text-brand-magenta mb-3">/ 403 · admin only</p>
            <h1 data-testid="access-denied-title" className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter uppercase leading-none">
                Not on <span className="text-brand-saffron italic font-serif-editorial">the list.</span>
            </h1>
            <p className="text-white/60 mt-6 max-w-md">
                The admin console is for Primates editors only. {role === "startup" ? "Head back to your brand dashboard." : "You can keep browsing — every corner of the site is open to shoppers."}
            </p>
            <div className="mt-8 flex gap-3">
                <Link to="/">
                    <Button className="bg-brand-saffron text-black hover:bg-brand-saffron/90 font-semibold rounded-md px-8 py-6 text-base">Home</Button>
                </Link>
                <Link to={role === "startup" ? "/dashboard" : "/discover"}>
                    <Button variant="outline" className="border-white/30 text-white bg-transparent hover:bg-white/10 font-semibold rounded-md px-8 py-6 text-base">
                        {role === "startup" ? "Your dashboard" : "Discover brands"}
                    </Button>
                </Link>
            </div>
        </main>
    );
}
